export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isLoadingTxs: (state) => state.isLoadingTxs,
  startingDate: (state) => state.startingDate,
  tokensChart: (state) => state.tokensChart,
  transactions: (state) => state.transactions,
  txEventHeight: (state) => state.txEventHeight,
  chartEventTokens: (state) => state.chartEventTokens,
};
